import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../globals";
import { ConfigurationServices } from "../services";
import { ConfigurationPage } from '../configuration';

/**
 * Generated class for the ConfigurationOrdersPage.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-configuration-orders',
    templateUrl: 'configuration-orders.html',
})
export class ConfigurationOrdersPage {
    orders_persons_elements: boolean;;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public configurationServices: ConfigurationServices,
        public globals: Globals) {
    }


    async updateIonToggle(orders_persons_elements) {
        this.globals.restaurant.orders_persons_elements = orders_persons_elements;
        this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
            'orders_persons_elements': orders_persons_elements,
        });
    }


    goBack() {
        this.globals.side_menu_config_active = '';
        if (this.navCtrl.canGoBack())
            this.navCtrl.pop();
        else
            this.navCtrl.setRoot(ConfigurationPage);
    }




}


// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-orders/configuration-orders.ts